/** Rastrové fotky (logo a nav ikony sú inline SVG komponenty). */
export const HOME_REDESIGN_IMAGES = {
  hero1: '/images/home-redesign/hero-1.jpg',
  hero2: '/images/home-redesign/hero-2.jpg',
  hero3: '/images/home-redesign/hero-3.jpg',
  ctaPhoto: '/images/home-redesign/cta-photo.jpg',
} as const;

export const APP_STORE_URL = 'https://apps.apple.com/app/id6753000653';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.chisme.chismosa';

export const INSTAGRAM_URL = 'https://www.instagram.com/chisme.social/';

export const TIKTOK_URL = 'https://www.tiktok.com/@chisme.social';

export const UGC_CREATOR_URL =
  'https://dramatic-heart-5c2.notion.site/3901d1cb98f480d287d4d734ea8d11b8?pvs=105';

/**
 * Single URL for install / open app (Branch, AppsFlyer, or your own redirect).
 * Set `REACT_APP_CHISME_APP_SMART_URL` at build time; default points at site path you can wire server-side.
 */
export const APP_SMART_LINK_URL =
  process.env.REACT_APP_CHISME_APP_SMART_URL ?? 'https://chisme.social/app';
